<div class="container">
  <app-close-button (click)="closeDialog()"></app-close-button>
  <div id="form"></div>
</div>
